import Immutable from 'seamless-immutable';
import { createReducer, onReadValue, completeState } from 'redux-recompose';

import { ORDER_TAKER_SIDEBAR_ITEMS } from '~app/screens/OrderTaker/components/OrderTakerSidebar/constants';

import { actions } from './actions';

const stateDescription = {
  activeTab: ORDER_TAKER_SIDEBAR_ITEMS.CREATE_ORDER.name,
  customer: null,
  deliveryType: 'pickup',
  store: null,
  storeData: null,
  deliveryTime: 'now',
  coupon: '',
  paymentMethod: '',
  products: [],
  menu: null,
  address: null,
  billing: {
    type: null,
    documentType: null,
    documentId: null,
    businessName: null,
    businessPhone: null,
    businessEmail: null,
    economicActivityCode: null
  },
  taxFree: false
};

const initialState = completeState(stateDescription);

const reducerDescription = {
  [actions.SET_ACTIVE_TAB]: onReadValue(),
  [actions.SET_CUSTOMER]: onReadValue(),
  [actions.SET_DELIVERY_TYPE]: onReadValue(),
  [actions.SET_STORE]: onReadValue(),
  [actions.SET_DELIVERY_TIME]: onReadValue(),
  [actions.SET_COUPON]: onReadValue(),
  [actions.SET_PAYMENT_METHOD]: onReadValue(),
  [actions.SET_PRODUCTS]: onReadValue(),
  [actions.SET_ADDRESS]: onReadValue(),
  [actions.SET_STORE_DATA]: onReadValue(),
  [actions.SET_BILLING]: onReadValue(),
  [actions.SET_TAX_FREE]: onReadValue(),
  [actions.GET_MENU_BY_ID]: (state, action) => {
    return onReadValue()(state, action);
  },
  [actions.CLEAR_ORDER]: () => new Immutable(initialState)
};

const reducer = createReducer(new Immutable(initialState), reducerDescription);

export default reducer;
